import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber } from '../../../common/Utils'
import { description } from 'devexpress-dashboard/model/index.metadata';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { SearchLayout } from './Layout';
import { IM, WM } from '../../../const/constants';
import form from '../../../wm/components/transactions/dataentry/form';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const LocationDataEntryList = (props) => {
    const dataGrid = useRef(null);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const lowercaseModule = props.Module.toLowerCase();
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "00267A3D-008B-45F2-AFD2-2C5797EE8DC8";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        CrateNumber: null,
        Description: null,
        Dimensions: null,
        Height: null,
        Width: null,
        Depth: null,
        GrossWeightQuantity: null,
        NetWeightQuantity: null,
        ReceivedDate: null,
        ShippedDate: null,
        RecordNumber: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        RecordType: null,
        Status: null,
        UserdefinedCode1: null,
        UserdefinedCode2: null,
        UserdefinedCode3: null,
        UserdefinedCode4: null,
        UserdefinedCode5: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        Module: props.Module,
        Relationship:null,
        SSCCNumber:null,
        TareWeightQuantity:null,
        VoyageNumber:null,
        Cube:null,
    };

    const [formFields, setformFields] = useState(initialFormFields);
    let createUrl = ""
    if (props.Module === WM)
        createUrl = "/wm/codes/location-data-entry-create";
    else if (props.Module === IM)
        createUrl = "/im/codes/location-data-entry-create";
    // Implement form load handler
    const handleFormLoad = useCallback(() => { }, []);

    const handleSearch = (e) => {
        e.event.stopPropagation();
        loadData(formFields);
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        loadData(initialFormFields);
    }

    useEffect(() => {
        loadData(initialFormFields);
    }, []);
    // Handle grid row selection to enable/disable Edit button
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };
    const loadData = (fields)=> {
        const filters = FillFilters(fields);
        let datasource = loadDatasource();
        datasource.filter(filters);
        setResultData(datasource);
    }
    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.IM.GetCrates}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    const handleValueChanged = (e) => { console.log(e) }

    const handleFieldValueChanged = (name, value, event) => { console.log(name, value, event) }

    const handleSelectedItemChanged = (name, event) => {
        console.log(name, event);
    };
    const handelEditClick = () => {
        let buttonUrl = "";
        if (props.Module === WM)
            buttonUrl = "/wm/codes/crate-data-entry-edit?id=" + rowId.current;
        else if (props.Module === IM)
            buttonUrl = "/im/codes/crate-data-entry-edit?id=" + rowId.current;
        history.push(buttonUrl);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            //   onSelectionChanged={e => {
                            //     if (e.currentTarget === e.target) {
                            //          selectionChanged(e, e.target);
                            //     }
                            //   }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6 style={{
                                                color: window._env_.Color2
                                            }}>Enter Your Query For Crates Data Entry</h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={() => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='7B1A2F46-2774-4D3D-895B-7472F751C868'
                                    layoutName='IMCrateDataEntrySearchForm'
                                    defaultFormSchema={SearchLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldValueChanged}
                                    handleSelectedItemChange={handleSelectedItemChanged}
                                    noSpacingBeforeFirstRow={true}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={searchPanelStatus ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <ColumnHeaderFilter />
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataType="string" dataField="RecordNumber" caption="Record #" />
                            <Column dataType="string" dataField="CrateNumber" caption="Crate Number" />
                            <Column dataType="string" dataField="Description" caption="Description" />
                            <Column dataType="string" dataField="Dimensions" caption="Dimensions" />
                            <Column dataType="string" dataField="Height" caption="Height" />
                            <Column dataType="string" dataField="Width" caption="Width" />
                            <Column dataType="string" dataField="Depth" caption="Depth" />
                            <Column dataType="string" dataField="GrossWeightQuantity" caption="Gross Weight Quantity" />
                            <Column dataType="string" dataField="NetWeightQuantity" caption="Net Weight Quantity" />
                            <Column dataType="string" dataField="ReceivedDate" caption="Received Date" />
                            <Column dataType="string" dataField="ShippedDate" caption="Shipped" />
                            <Column visible={false} dataType="string" dataField="CreationDateTime" caption="Creation Date Time" />
                            <Column visible={false} dataType="string" dataField="CreationUserId" caption="Creation User Id" />
                            <Column visible={false} dataType="string" dataField="LastUpdateDateTime" caption="Last Update Date Time" />
                            <Column visible={false} dataType="string" dataField="LastUpdateUserId" caption="Last Update User Id" />
                            <Column visible={false} dataType="string" dataField="RecordType" caption="Record Type" />
                            <Column visible={false} dataType="string" dataField="Status" caption="Status" />
                            <Column visible={false} dataType="string" dataField="UserdefinedCode1" caption="Code 1" />
                            <Column visible={false} dataType="string" dataField="UserdefinedCode2" caption="Code 2" />
                            <Column visible={false} dataType="string" dataField="UserdefinedCode3" caption="Code 3" />
                            <Column visible={false} dataType="string" dataField="UserdefinedCode4" caption="Code 4" />
                            <Column visible={false} dataType="string" dataField="UserdefinedCode5" caption="Code 5" />
                            <Column visible={false} dataType="string" dataField="UserDefinedReference1" caption="Reference 1" />
                            <Column visible={false} dataType="string" dataField="UserDefinedReference2" caption="Reference 2" />
                            <Column visible={false} dataType="string" dataField="UserDefinedReference3" caption="Reference 3" />
                            <Column visible={false} dataType="string" dataField="UserDefinedReference4" caption="Reference 4" />
                            <Column visible={false} dataType="string" dataField="UserDefinedReference5" caption="Reference 5" />
                            <Column visible={false} dataType="datetime" dataField="UserDefinedDate1" caption="Date 1" />
                            <Column visible={false} dataType="datetime" dataField="UserDefinedDate2" caption="Date 2" />
                            <Column visible={false} dataType="datetime" dataField="UserDefinedDate3" caption="Date 3" />
                            <Column visible={false} dataType="datetime" dataField="UserDefinedDate4" caption="Date 4" />
                            <Column visible={false} dataType="datetime" dataField="UserDefinedDate5" caption="Date 5" />
                            <Column visible={false} dataType="number" dataField="UserDefinedQuantity1" caption="Quantity 1" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column visible={false} dataType="number" dataField="UserDefinedQuantity2" caption="Quantity 2" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column visible={false} dataType="number" dataField="UserDefinedQuantity3" caption="Quantity 3" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column visible={false} dataType="number" dataField="UserDefinedQuantity4" caption="Quantity 4" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column visible={false} dataType="number" dataField="UserDefinedQuantity5" caption="Quantity 5" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column visible={false} dataType="string" dataField="Relationship" caption="Relationship" />
                            <Column visible={false} dataType="string" dataField="SSCCNumber" caption="SSCC Number" />
                            <Column visible={false} dataType="string" dataField="TareWeightQuantity" caption="Tare Weight" />
                            <Column visible={false} dataType="string" dataField="VoyageNumber" caption="Voyage #" />
                            <Column visible={false} dataType="string" dataField="Cube" caption="Cube" />
                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(LocationDataEntryList);